import {
  LOAD_MACHINES,
  LOAD_MACHINES_SUCCESS,
  LOAD_MACHINES_ERROR,
} from "../Types/machines.constants";

const INITIAL_STATE = {
  loading: false,
  machines: [],
  error: null,
};

export const machineListReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case LOAD_MACHINES:
      return { ...state, loading: true, machines: [] };
    case LOAD_MACHINES_SUCCESS:
      return {
        ...state,
        loading: false,
        machines: action.payload,
      };
    case LOAD_MACHINES_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
